<div class="resumo-card" *ngIf="appearance === 'modern'">
  <div class="resumo-card__header"
    role="button"
    tabindex="0"
    [attr.aria-expanded]="resumoExpanded"
    (click)="toggleResumo()"
    (keydown.enter)="toggleResumo()"
    (keydown.space)="$event.preventDefault(); toggleResumo()">
    <span class="resumo-card__title">Resumo do lote</span>
    <span class="resumo-card__toggle-label">{{ resumoExpanded ? 'ocultar' : 'mostrar' }}</span>
  </div>

  <div class="resumo-card__body" *ngIf="resumoExpanded">
    <div class="resumo-card__grid">
      <ng-container *ngFor="let info of infosDetailsArray; let i = index">
        <div *ngIf="!info.isHidden && !info.editField" class="resumo-field">
          <p class="resumo-field__label">
            {{ info.title }}
            <button
              *ngIf="info.action && lote?.IsInvoiced"
              type="button"
              class="resumo-field__edit"
              (click)="handleInvoiceInfo(i)">
              <app-svg-icon src="assets/icons/edit-icon.svg" width="12px"></app-svg-icon>
            </button>
          </p>
          <p
            class="resumo-field__value"
            [class.resumo-field__value--emphasis]="info.title === 'Status do Lote:' || info.title === 'Valor Total de Financiamento:' || info.title === 'Valor Faturado:'">
            {{ info.value || '-' }}
          </p>
        </div>

        <div *ngIf="!info.isHidden && info.editField && info.title !== 'Observação:'" class="resumo-field">
          <p class="resumo-field__label">{{ info.title }}</p>
          <div class="resumo-field__edit-row" *ngIf="!lote?.PaymentDate">
            <app-c-input inputType="date" class="vw-100" [formControl]="paymentDate" [combo]="true"></app-c-input>
            <button [disabled]="paymentDate.invalid" class="resumo-field__save-btn" (click)="handlePaymentDate()">
              <app-svg-icon src="../../../../assets/icons/save-icon.svg" color="white" width="15px" height="15px"></app-svg-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="resumo-card__observacao">
      <ng-container *ngFor="let info of infosDetailsArray">
        <div *ngIf="!info.isHidden && info.editField && info.title === 'Observação:'" class="resumo-field resumo-field--full">
          <div class="resumo-field__edit-row align-flex-end">
            <app-c-input inputType="textarea" class="vw-100" [formControl]="Observacao" label="Observação:" [maxlength]="500"></app-c-input>
            <button [disabled]="false" class="resumo-field__save-btn" (click)="handleObservacao()">
              <app-svg-icon src="../../../../assets/icons/save-icon.svg" color="white" width="15px" height="15px"></app-svg-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="content"
  *ngIf="appearance === 'legacy'"
  [ngClass]="{
    'mt-40 mb-30': this.typeDetail !== DetailLotEnum.Modal
  }">
  <div class="content-infos d-flex">
    <ng-container *ngFor="let info of infosDetailsArray; let i = index">
      <div *ngIf="!info.isHidden"
        class="infos-group group d-flex direction-column row-gap-8">
        <ng-container *ngIf="!info.editField">
          <span class="group-title">
            {{ info.title }}
            <ng-container class="title-edit edit"
              *ngIf="info.action && lote?.IsInvoiced">
              <button class="title-edit edit" (click)="handleInvoiceInfo(i)">
                <app-svg-icon src="assets/icons/edit-icon.svg"
                  width="14px"></app-svg-icon>
              </button>
            </ng-container>
          </span>
          <span class="group-value"
            [ngClass]="{
              emphasis:info.title === 'Status do Lote:' || info.title === 'Parceiro:',
              'destaque': info.value === 'Liberado Manual'
            }">
            {{ info.value || "-" }}
          </span>
        </ng-container>

        <ng-container *ngIf="info.editField && info.title!=='Observação:'">
          <span class="group-title"> {{ info.title }} </span>


          <div class="row pr-15 align-flex-end" *ngIf="!lote?.PaymentDate">
            <app-c-input inputType="date"
              class="vw-100"
              [formControl]="paymentDate"
              [combo]="true"></app-c-input>
            <button [disabled]="paymentDate.invalid"
              class="btn-save-input"
              (click)="handlePaymentDate()">
              <app-svg-icon src="../../../../assets/icons/save-icon.svg"
                color="lightGray"
                width="15px"
                height="15px">
              </app-svg-icon>
            </button>
          </div>
        </ng-container>
      </div>

    </ng-container>
  </div>

  <div class="content-infos d-flex" style="padding-top:15px">
    <ng-container *ngFor="let info of infosDetailsArray; let i = index">


      <ng-container *ngIf="info.editField && info.title==='Observação:'">

        <div *ngIf="!info.isHidden" class="" style="width:100%;">          

          <div class="row pr-15 align-center">
            <app-c-input inputType="textarea" class="vw-100" [formControl]="Observacao" label="Observação:" [maxlength]="500"></app-c-input>

            <button [disabled]="false" class="btn-save-comment" (click)="handleObservacao()">
              <app-svg-icon src="../../../../assets/icons/save-icon.svg"
                color="secondary"
                width="15px"
                height="15px">
              </app-svg-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>

</div>
